// extracted by mini-css-extract-plugin
export default {"videoContainer":"videoPreview_videoContainer__j4PUu","videoPreview":"videoPreview_videoPreview__MfbWk"};